import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as Chart from 'chart.js';
import { Subscription } from 'rxjs';
import { AuthService } from "../../services/auth-service/auth.service";
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { ServiceProviderService } from '../../services/service-provider/service-provider.service';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss']
})
export class LineChartComponent implements OnInit {
  categorySubscription: Subscription
  @Input() backgroundColorip: any;
  @Input() datasetip: any = [
    {
      label: 'ACTIVE',
      borderColor: '#42f5ec',
      backgroundColor: '#42f5ec',

      lineTension: 0,
      fill: false,
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    {
      label: 'EXPIRED',
      borderColor: '#f54254',
      lineTension: 0,
      backgroundColor: '#f54254',

      fill: false,
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

    },
    {
      label: 'APPROVED',
      borderColor: '#f59642',
      lineTension: 0,
      backgroundColor: '#f59642',
      fill: false,
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

    },
    {
      label: 'INPROGRESS',
      borderColor: '#f542ef',
      backgroundColor: '#f542ef',
      lineTension: 0,
      fill: false,
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

    }
  ];
  @Input() labelsip: any;
  @Input() barChartTitle: any;
  @Input() legend: boolean = true;
  // datasetip: any
  public chart: any = null;
  // filters 
  // week, month, 3months, 6months, 12months
  filterValues: any = [
    {
      name: 'week',
      displayName: 'Week'
    },
    {
      name: 'month',
      displayName: '1 Month'
    },
    {
      name: '3months',
      displayName: '3 Months'
    },
    {
      name: '6months',
      displayName: '6 Months'
    },
    {
      name: '12months',
      displayName: '12 Months'
    }
  ];
  selectedFilterValue: any = this.filterValues[4];
  categories: any;
  selectedCategory: any
  SArevenueSummarySubscription: Subscription;
  sendData: any;
  sendlabels: any;
  countryChanges: any;
  language: any;


  constructor(
    private spService: ServiceProviderService,
    private dashboardService: DashboardService,
    private translateService: TranslateService,
    private authService: AuthService
  ) {

    this.language = this.authService.getLanguage();

    this.setNames()
    this.translateService.onLangChange.subscribe(res => {
      this.setNames()
    })

    // country filter
    this.dashboardService._getCountryDetails.subscribe((res: any) => {
      console.log('dashboardService._getCountry', res);

      // this.countryChanges = res?.name
      this.countryChanges = res.name.split('(')[0].trim()
      if (this.countryChanges) {
        this.getAdvertisement()
      }

    })
    // chart filter
    this.dashboardService._getSAAdvertisementChartObserver.subscribe((res: any) => {
      console.log('========================_getSAAdvertisementChartObserver======================', res.activeAdvertisementCount);

      this.datasetip[0].data = res?.activeAdvertisementCount;
      this.datasetip[1].data = res?.expiredAdvertisementCount;
      this.datasetip[2].data = res?.approvedAdvertisementCount;
      this.datasetip[3].data = res?.requestedAdvertisementCount;
      console.log('datasetip', this.datasetip);

      this.labelsip = res?.data?.labelWithFormat
      this.renderChart()
    })
  }

  setNames() {
    this.datasetip = [
      {
        label: this.translateService.instant('page.active'),
        borderColor: '#42f5ec',
        backgroundColor: '#42f5ec',

        lineTension: 0,
        fill: false,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        label: this.translateService.instant('page.expired'),
        borderColor: '#f54254',
        lineTension: 0,
        backgroundColor: '#f54254',

        fill: false,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

      },
      {
        label: this.translateService.instant('page.approved'),
        borderColor: '#f59642',
        lineTension: 0,
        backgroundColor: '#f59642',
        fill: false,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

      },
      {
        label: this.translateService.instant('page.inprogress'),
        borderColor: '#f542ef',
        backgroundColor: '#f542ef',
        lineTension: 0,
        fill: false,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

      }
    ]
  }

  ngOnInit() {

    this.filterValues = [
      {
        name: 'week',
        displayName: this.translateService.instant('page.week')
      },
      {
        name: 'month',
        displayName: this.translateService.instant('page.onemonth')
      },
      {
        name: '3months',
        displayName: this.translateService.instant('page.threemonths')
      },
      {
        name: '6months',
        displayName: this.translateService.instant('page.sixmonths')
      },
      {
        name: '12months',
        displayName: this.translateService.instant('page.twelvemonths')
      }
    ];
    this.selectedFilterValue = this.filterValues[4];

    this.translateService.onLangChange.subscribe(resp => {
      this.filterValues = [
        {
          name: 'week',
          displayName: this.translateService.instant('page.week')
        },
        {
          name: 'month',
          displayName: this.translateService.instant('page.onemonth')
        },
        {
          name: '3months',
          displayName: this.translateService.instant('page.threemonths')
        },
        {
          name: '6months',
          displayName: this.translateService.instant('page.sixmonths')
        },
        {
          name: '12months',
          displayName: this.translateService.instant('page.twelvemonths')
        }
      ];
      this.selectedFilterValue = {
        ...this.filterValues[4],
        displayName: this.translateService.instant('page.twelvemonths')
      };
    })


    this.getAllCategories()
    this.getAdvertisement()
  }
  renderChart() {
    this.chart ? this.chart.destroy() : ''

    Chart.defaults.global.animation.duration = 3000

    this.chart = new Chart("line", {
      type: 'line',
      data: {
        // labels: ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"],
        labels: this.labelsip,
        datasets: this.datasetip
      },
      options: {

        legend: {
          display: this.legend,
          position: 'bottom',
          labels: {
            usePointStyle: true
          }
        },
      }
    },
    );
  }
  // Advertisement
  getAdvertisement() {

    const payload = {
      roleName: 'superadmin',  //required
      country: this.countryChanges ? this.countryChanges : '',  // india or India
      filtertype: this.selectedFilterValue ? this.selectedFilterValue.name : '', //  week, month, 3months, 6months, 12months 
      categoryId: this.selectedCategory ? this.selectedCategory._id : '' //
    }
    this.SArevenueSummarySubscription = this.dashboardService.advertisements(payload).subscribe((res: any) => {

      if (res.success) {

        this.sendData = res?.data;
        this.sendlabels = res?.data.sendlabels
        this.dashboardService.setSAAdvertisementData(this.sendData);
        this.datasetip[0].data = res?.data?.activeAdvertisementCount;
        this.datasetip[1].data = res?.data?.expiredAdvertisementCount;
        this.datasetip[2].data = res?.data?.approvedAdvertisementCount;
        this.datasetip[3].data = res?.data?.requestedAdvertisementCount;

        this.labelsip = res?.data?.labelWithFormat
        this.renderChart()
      } else {


        this.sendData = [];
        this.sendlabels = []
        this.dashboardService.setSAAdvertisementData(this.sendData);

      }

    }, err => {

      this.sendData = [];
      this.sendlabels = []
      this.dashboardService.setSAAdvertisementData(this.sendData);
    })
  }


  getAllCategories() {
    this.categorySubscription = this.spService.categoryListing().subscribe(res => {
      this.categories = res
    }, err => {

    })
  }
  onFilterValueChange(filter) {
    this.selectedFilterValue = filter
    this.getAdvertisement()
  }
  onCategoryChange(category) {
    this.selectedCategory = category
    this.getAdvertisement()
  }
}